import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import urls from '../../../../networkRequests/apiClient/endpoints'
import errorHandler from '../../../../shared/functions/ErrorHandler/errorHandler.functions'
import { ApiErrorResponse } from '../../../../shared/types/api.types'
import { createFulfillmentOrderPaymentIntentApi } from './createFulfillmentOrderPaymentIntent.api'
import createFulfillmentOrderPaymentIntentInitialState from './createFulfillmentOrderPaymentIntent.initialState'
import {
  CreateFulfillmentOrderPaymentIntentErrorResponse,
  CreateFulfillmentOrderPaymentIntentRequestPayload
} from './createFulfillmentOrderPaymentIntent.types'

export const createFulfillmentOrderPaymentIntent = createAsyncThunk(
  urls.payments.createFulfillmentOrderPaymentIntent,
  async (payload: CreateFulfillmentOrderPaymentIntentRequestPayload, { rejectWithValue }) => {
    const { request, onSuccess } = payload

    try {
      const response = await createFulfillmentOrderPaymentIntentApi(request)

      onSuccess && onSuccess()

      return response
    } catch (error) {
      errorHandler.handleApiError(error as ApiErrorResponse)

      return rejectWithValue(error)
    }
  }
)

const createFulfillmentOrderPaymentIntentSlice = createSlice({
  name: urls.payments.createFulfillmentOrderPaymentIntent,
  initialState: createFulfillmentOrderPaymentIntentInitialState,
  reducers: {
    resetCreateFulfillmentOrderPaymentIntent: (state) => {
      state.loading = false
      state.error = null
      state.success = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(createFulfillmentOrderPaymentIntent.pending, (state) => {
        state.loading = true
        state.error = null
        state.success = null
      })
      .addCase(createFulfillmentOrderPaymentIntent.fulfilled, (state, { payload }) => {
        state.loading = false
        state.success = payload
        state.error = null
      })
      .addCase(createFulfillmentOrderPaymentIntent.rejected, (state, { payload }) => {
        state.loading = false
        state.error = payload as CreateFulfillmentOrderPaymentIntentErrorResponse
        state.success = null
      })
  }
})

export const {
  actions: createFulfillmentOrderPaymentIntentActions,
  reducer: createFulfillmentOrderPaymentIntentReducer
} = createFulfillmentOrderPaymentIntentSlice

export const { resetCreateFulfillmentOrderPaymentIntent } = createFulfillmentOrderPaymentIntentActions

export default createFulfillmentOrderPaymentIntentSlice.reducer
